export type LngLatBoundsCorners = [[number, number], [number, number]];

/**
 * Whether a lng/lat sits inside a `[[minLng, minLat], [maxLng, maxLat]]` extent.
 * Used to skip re-framing a spatial dataset the user is already looking at
 * (map-camera plan §15.2).
 */
export function isLngLatWithinBounds(lngLat: { lng: number; lat: number }, bounds: LngLatBoundsCorners): boolean {
  const [[minLng, minLat], [maxLng, maxLat]] = bounds;
  return lngLat.lng >= minLng && lngLat.lng <= maxLng && lngLat.lat >= minLat && lngLat.lat <= maxLat;
}

/**
 * Whether the map is already showing this spatial dataset, and framing it would
 * therefore be a yank rather than a service — a card remounting from an identify
 * click, not a fresh pick from the list.
 *
 * Identity, not geometry. The camera rule (map-camera plan §15.2) used to rest on
 * {@link isLngLatWithinBounds} alone, which reads as "already looking at it" only
 * for a small extent: any map view sits inside a country-wide or global dataset's
 * bbox, so selecting one from the list never framed it and the camera just sat
 * where it was. Only a dataset that was ALREADY on the map can be already framed.
 */
export function isAlreadyFramedDataset(
  activeDatasetId: number | string | null | undefined,
  datasetId: number | string | null | undefined
): boolean {
  if (activeDatasetId == null || datasetId == null) return false;
  return String(activeDatasetId) === String(datasetId);
}
